export default "__VITE_ASSET__wMB$eFeV__";